import { render, staticRenderFns } from "./GiftCardStore.vue?vue&type=template&id=2c9cd42c&scoped=true"
import script from "./GiftCardStore.vue?vue&type=script&lang=js"
export * from "./GiftCardStore.vue?vue&type=script&lang=js"
import style0 from "./GiftCardStore.vue?vue&type=style&index=0&id=2c9cd42c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9cd42c",
  null
  
)

export default component.exports